export type TxtQuickColorKey = 'green' | 'orange' | 'red';

/** Shared with Notes / Tasks / External Assets quick-color shortcuts. */
export const TXT_QUICK_COLOR_PALETTE = {
    text: {
        green: '#1f5d2a',
        orange: '#8a4b00',
        red: '#8a1f1f',
    },
    background: {
        green: '#c8e6c9',
        orange: '#ffd8a8',
        red: '#f5c2c7',
    },
} as const;

export const TXT_QUICK_COLOR_KEY_MAP: Record<'g' | 'o' | 'r', TxtQuickColorKey> = {
    g: 'green',
    o: 'orange',
    r: 'red',
};

export function isTxtQuickColorShortcutKey(key: string): key is 'g' | 'o' | 'r' {
    return key === 'g' || key === 'o' || key === 'r';
}
